// Component Libraries
import NavBar from "../NavBar/NavBar";
import SideBar from "../SideBar/SideBar";
import TemplateDashboardContent from "../TemplateDashboardContent/TemplateDashboardContent";

import "./TemplateDashboard.scss";

const TemplateDashboard = () => {
  return (
    <div className="dashboard-outer-container">
      <NavBar />
      <div className="dashboard-outer-content-container">
        <div className="sidebar-container">
          <SideBar />
        </div>
        <TemplateDashboardContent />
      </div>
    </div>
  );
};

export default TemplateDashboard;
